var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-loader"},[_c('div',{staticClass:"modal-loader__container"},[_c('ui-loader',{attrs:{"variant":'gray'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }